var path = 'app/scripts/modules/core/src/instance/loadBalancer/health.html';
var html = "<div style=\"display:inline-block\" uib-tooltip=\"{{healthState !== 'Up' ? loadBalancer.description : ''}}\" tooltip-placement=\"left\">\n  <span ng-if=\"healthState === 'Up'\"\n        class=\"glyphicon glyphicon-Up-triangle\"></span>\n  <span ng-if=\"healthState === 'OutOfService' || healthState === 'Down'\"\n        class=\"glyphicon glyphicon-Down-triangle\"></span>\n  <span>{{name}}</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/instance/loadBalancer/health.html
// module id = 1100
// module chunks = 0